<ng-container *transloco="let t">
  <button
    class="notification-dropdown__trigger"
    mat-icon-button
    [matMenuTriggerFor]="notificationMenu"
    [attr.aria-label]="t('notifications.dropdown.title')"
  >
    <span
      class="notification-dropdown__badge-wrap"
      [matBadge]="notificationService.unreadCount || null"
      matBadgeColor="accent"
      matBadgeSize="small"
      matBadgeOverlap="true"
    >
      <mat-icon>notifications</mat-icon>
    </span>
  </button>

  <mat-menu #notificationMenu="matMenu" class="notification-dropdown-panel" xPosition="before">
    <div class="notification-dropdown">
      <div class="notification-dropdown__header">
        <h3>{{ t('notifications.dropdown.title') }}</h3>
        @if (pushEnabled) {
          <button
            mat-icon-button
            (click)="togglePush($event)"
            [matTooltip]="pushTooltipText"
          >
            <mat-icon>{{ pushSubscribed ? 'notifications_off' : 'notifications_active' }}</mat-icon>
          </button>
        }
      </div>

      <mat-divider />

      <div class="notification-dropdown__list">
        @for (notification of notificationService.notifications; track notification.id) {
          @if ($index < 8) {
            <div
              class="notification-dropdown__item"
              [class.notification-dropdown__item--unread]="isUnread(notification)"
              matRipple
              tabindex="0"
              role="button"
              (click)="openDetail(notification)"
              (keydown.enter)="openDetail(notification)"
            >
              <div
                class="notification-dropdown__item-icon"
                [style.background-color]="notificationService.getTypeBadgeBackgroundColor(notification)"
              >
                <mat-icon [class]="notificationService.inAppTypeMatIconClasses">{{
                  notificationService.getTypeIconName(notification)
                }}</mat-icon>
              </div>
              <div class="notification-dropdown__item-content">
                <div class="notification-dropdown__item-title">{{ notification.title }}</div>
                <div class="notification-dropdown__item-message">{{ notification.message }}</div>
                <div class="notification-dropdown__item-time">{{ getRelativeTime(notification.expiresAt) }}</div>
              </div>
              @if (isUnread(notification)) {
                <div class="notification-dropdown__item-dot"></div>
              }
            </div>
            @if ($index < 7 && !$last) {
              <mat-divider />
            }
          }
        } @empty {
          <div class="notification-dropdown__empty">
            <mat-icon>notifications_none</mat-icon>
            <p>{{ t('notifications.dropdown.empty') }}</p>
          </div>
        }
      </div>

      <mat-divider />
      <div class="notification-dropdown__footer">
        <a mat-button routerLink="/notifications" color="primary">
          {{ notificationService.notifications.length > 0 ? t('notifications.dropdown.show_all') : t('notifications.center.title') }}
        </a>
      </div>
    </div>
  </mat-menu>
</ng-container>
